<app-simple-responsive-frame>
    <div class="bg-white">
        <div class="custom-grid-card-center">
            <h2 class="section-title">¿Qué tipo de propiedad tienes?</h2>

            <div class="property-grid">
                <div
                    *ngFor="let item of segmentPropertyDtos; let i = index"
                    (click)="selectItem(i)"
                    [ngClass]="{ 'selected': item.selected }"
                    class="property-card"
                >
                    <div class="property-card-content">
                        <img
                            *ngIf="item.imageUrl"
                            [src]="item.imageUrl"
                            alt="{{ item.name }}"
                            class="property-icon"
                        />
                        <div class="property-labels">
                            <span class="property-title">{{ item.name }}</span>
                            <span class="property-subtitle" *ngIf="item.description">{{ item.description }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <app-page-navigation-bar
        [value]="10"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="mode"
        [stepKey]="'segments'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
    ></app-page-navigation-bar>
</app-simple-responsive-frame>
<p-toast></p-toast>

